import NewsTipActionModal from './NewsTipActionModal'
export default NewsTipActionModal
